import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { HEADER_NAV_ICON_VIEWBOX, HEADER_NAV_ICONS, HeaderNavIconId } from './header-nav-icons';

@Component({
  selector: 'app-header-nav-icon',
  standalone: true,
  template: `
    <svg
      class="nav-ico-svg"
      [attr.viewBox]="viewBox()"
      aria-hidden="true"
      focusable="false"
    >
      @for (path of paths(); track path.d) {
        <path
          [attr.d]="path.d"
          [attr.fill-rule]="path.fillRule"
          fill="currentColor"
        />
      }
    </svg>
  `,
  styleUrl: './header-nav-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderNavIconComponent {
  readonly iconId = input.required<HeaderNavIconId>();

  readonly paths = computed(() => HEADER_NAV_ICONS[this.iconId()] ?? []);
  readonly viewBox = computed(() => HEADER_NAV_ICON_VIEWBOX[this.iconId()] ?? '0 0 16 16');
}
